// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { TRAINING_URL } from '../../api/constants.js';

// import type { MapStateToProps } from 'react-redux';

type OwnProps = {||};

type MappedState = {|
  URL: $ElementType<ReduxState, 'URL'>,
  breadcrumbs: $ElementType<ReduxState, 'breadcrumbs'>,
  organization: $ElementType<ReduxState, 'organization'>,
  organizationMenu: $ElementType<ReduxState, 'organizationMenu'>,
  accessgroups: $ElementType<ReduxState, 'accessgroups'>
|};

type Props = {|
  ...OwnProps,
  ...MappedState
|};

class Breadcrumbs extends React.PureComponent<Props> {
  render() {
    const { URL, breadcrumbs, organization, organizationMenu, accessgroups } = this.props;

    if (!URL || !breadcrumbs) return null;

    return (
      <ol className="breadcrumb">
        <li>
          <a className="no-underline" href={URL.uri}>
            <span className="icon home"></span> Home
          </a>
        </li>
        {Array.isArray(breadcrumbs) && breadcrumbs.length
          ? breadcrumbs.map((el, i) =>
              i !== breadcrumbs.length - 1 ? (
                <li
                  key={`el-${el.url}-${i}`}
                  className={`${
                    organization &&
                    el.url === `org/${organization.unique}/organizations/dashboard` &&
                    el.isDropdown
                      ? 'breadcrumb-dropdown'
                      : ''
                  }`}
                >
                  {organization &&
                  el.url === `org/${organization.unique}/organizations/dashboard` &&
                  el.isDropdown ? (
                    <React.Fragment>
                      <a tabIndex="0" role="button" className="breadcrumb-dropdown-toggle">
                        <span className="icon list" /> {el.name}
                      </a>
                      <span className="breadcrumb-dropdown-toggle-after" />
                    </React.Fragment>
                  ) : (
                    <a className="no-underline" href={`${URL.uri}/${el.url}/`}>
                      {el.name}
                    </a>
                  )}
                  {organization &&
                  el.url === `org/${organization.unique}/organizations/dashboard` &&
                  el.isDropdown ? (
                    <ul className="multilevel-list breadcrumb-dropdown-list menu-organization">
                      {organizationMenu && organizationMenu.length ? (
                        organizationMenu.map(group =>
                          group.showInMenu === '1' ? (
                            group.unique === 'trainingView' ? (
                              // Training points at the EXTERNAL training module
                              // (env host), NOT `${URL.org}/trainingView/`.
                              <li key={group.unique}>
                                <a href={TRAINING_URL} target="_blank" rel="noopener noreferrer">
                                  {group.name}
                                </a>
                              </li>
                            ) : group.unique === 'resourceView' || group.unique === 'productsView' ? (
                              <span key={group.unique}>
                                <li>
                                  <a
                                    href={`${URL.org}/${group.model}/${
                                      group.action ? `${group.action}/` : ''
                                    }`}
                                  >
                                    {group.name}
                                  </a>
                                </li>
                                {group.unique === 'productsView' ? (
                                  accessgroups.organizationEdit && accessgroups.productsView ? (
                                    <li>
                                      <a href={`${URL.org}/organizations/edit/`}>
                                        Financial Settings
                                      </a>
                                    </li>
                                  ) : null
                                ) : (
                                  <li>
                                    <a href={`${URL.org}/hangars/`}>Aircraft Status</a>
                                  </li>
                                )}
                              </span>
                            ) : (
                              <li key={group.unique}>
                                <a
                                  href={`${URL.org}/${group.model}/${
                                    group.action ? `${group.action}/` : ''
                                  }`}
                                >
                                  {group.name}
                                </a>
                              </li>
                            )
                          ) : null
                        )
                      ) : (
                        <li className="multilevel-list-item text-muted">no active links yet</li>
                      )}
                    </ul>
                  ) : null}
                </li>
              ) : el.static ? (
                <li key={`el-${el.url}-${i}`} className="active">
                  {el.name}
                </li>
              ) : null
            )
          : null}
      </ol>
    );
  }
}

const mapStateToProps = state => ({
  URL: state.URL,
  organization: state.organization,
  breadcrumbs: state.breadcrumbs,
  organizationMenu: state.organizationMenu,
  accessgroups: state.accessgroups
});

export default connect(
  mapStateToProps,
  {}
)(Breadcrumbs);
